import { BasicRequest } from "./basicRequest";

export class DeleteCustomerRequest extends BasicRequest{

    public customerId! : number;
    public physicalDelete : boolean = false;

    constructor(){
        super();
    }
}